"use client"

import { useEffect, useState } from "react"
import AdSlot from "./AdSlot"

interface DesktopAdProps {
  adSlot: string
  adFormat?: "auto" | "fluid" | "rectangle" | "vertical" | "horizontal"
  style?: React.CSSProperties
  className?: string
  position?: string
  recommendedSize?: string
  notes?: string
}

export default function DesktopAd(props: DesktopAdProps) {
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    // Check if we're on xl screen or larger (1280px+)
    const checkScreenSize = () => {
      setShouldRender(window.innerWidth >= 1280)
    }

    // Check on mount
    checkScreenSize()

    // Check on resize
    window.addEventListener("resize", checkScreenSize)
    return () => window.removeEventListener("resize", checkScreenSize)
  }, [])

  // Only render ad on xl screens and up
  if (!shouldRender) return null

  return <AdSlot {...props} />
}
